import { Link } from 'react-router-dom'

import { ProfileItem, ProfileItemProps } from './ProfileItem'

interface Props {
  items?: ProfileItemProps[]
  itemsShowed?: number
}

export const ProfileList = ({ items = [], itemsShowed }: Props) => {
  const profileItems = items.slice(0, itemsShowed)
  const restItems =
    itemsShowed && items.length > itemsShowed ? items.length - itemsShowed : 0

  return (
    <div>
      {profileItems.map((item, i) => {
        return <ProfileItem key={i} item={item} />
      })}

      {restItems !== 0 && <Link to="#">{`+${restItems}`}</Link>}
    </div>
  )
}

ProfileList.defaultProps = {
  itemsShowed: 3,
  align: 'right'
}
